// Angular
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// Service
import { ViewsService } from '../../../../../../../../services/views.service';
import { CVfUtilsService } from '../../../../../../../services/cvf-utils.service';
// Model
import { FormControl, FormGroup } from '@angular/forms';
import { SCHEMA_TYPE } from '../../../../../../../../models/enums.model';
import { SmartTagTemplateForm } from '../../../model/smart-tag-template-form.model';
import { SmartTagDeficiencyModel } from '../../../model/smartTagDeficiency';
import { SmartTagFormControlModel } from '../../../model/smart-tag-form-control.model';

@Component({
	selector: 'cv-schema-render-smart-tag-deficiency-template',
	templateUrl: './smart-tag-deficiency-template.component.html',
})
export class SmartTagDeficiencyTemplateComponent extends SmartTagTemplateForm implements OnInit {

	@Input() smartTagModel: SmartTagDeficiencyModel = null;
	@Input() selectedSmartTagItem: any = null;
	@Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

	customId = new Date().getTime();
	public orderSchema = '';

	get schemaShouldShowComplexForm(): boolean {
		let response = false;
		const schemasShouldShow = [
			SCHEMA_TYPE.CVDS_40.toString(),
			SCHEMA_TYPE.INSPECTIONLESS_1.toString()
		];

		response = schemasShouldShow.indexOf(this.orderSchema) > -1

		return response
	}

	constructor(
		private viewsService: ViewsService,
		protected cvfUtils: CVfUtilsService
	) {
		super(cvfUtils);
	}

	ngOnInit() {

		this.orderSchema = this.viewsService.order.schema;
		// Basic Form
		this.innerForm = new FormGroup({
			description: new FormControl(this.smartTagModel.description)
		});

		// Review if the selected Smart Tag Contain Form Controls
		this.prepareDynamicSmartTagFormControls(this.selectedSmartTagItem);

		switch (this.orderSchema) {
			case SCHEMA_TYPE.CVDS_40:
			case SCHEMA_TYPE.INSPECTIONLESS_1:

				this.formControl.forEach((formControl: SmartTagFormControlModel) => {
					this.addDynamicFormControl(formControl, this.smartTagModel);
				});

				this.innerForm.addControl('deficiencySeverity', new FormControl(this.smartTagModel.deficiencySeverity));

				break;
		}

		// Everytime the Form Change
		this.innerForm.valueChanges.subscribe(() => this.onValuesChange());
	}

	/**
	 * Emit values and status of this Form, for inner components and library too
	 * @private
	 */
	public onValuesChange(): void {
		const formValue = this.processOutputObject(this.smartTagModel);
		this.valueChange.next({ valid: this.innerForm.valid, value: formValue });
	}

}
